import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class OrgInviteIncoming extends BaseAction {
    public static userVisible:boolean = false;
    public static getTitle:Function = () => Locale.gettext('Org Join Request Received');
    public static getDescription:Function = () => Locale.gettext('A user invited you to join their organization');
    public static supportedRoutes:string[] = [ "push", "email" ];
}